//
//
//
//

import ModuleDashboardAdminComponentVue from '@/components/ModuleDashboardAdminComponent.vue';
export default {
  components: {
    ModuleDashboardAdminComponentVue: ModuleDashboardAdminComponentVue
  },
  data: function data() {
    return {
      title: 'Reporte de Calidad de Atributos',
      description: 'Pagina de administracion del reporte.',
      id: 'attribute-quality-report',
      module: 'marketplace-atributos'
    };
  }
};